const loginLogic = () => {
	const sellernumberTextField = document.getElementById('sellernumber-textfield');
	const passwordTextField = document.getElementById('password-textfield');
	const loginButton = document.getElementById('login-button');

	//ON INPUT CHANGE LOGIC
	sellernumberTextField?.addEventListener('input', fieldsAreEmpty);
	passwordTextField?.addEventListener('input', fieldsAreEmpty);

	//AUTOFILLED LOGIC 
	const AUTOFILLED = 'is-autofilled'
	const onAutoFillStart = (element) => {
		fieldsAreEmpty();
		element.classList.add(AUTOFILLED)
	}
	const onAutoFillCancel = (element) => element.classList.remove(AUTOFILLED)
	const onAnimationStart = ({ target, animationName }) => {
		switch (animationName) {
			case 'onAutoFillStart':
				return onAutoFillStart(target)
			case 'onAutoFillCancel':
				return onAutoFillCancel(target)
		}
	}
	document.querySelector('input').addEventListener('animationstart', onAnimationStart, false)

	function fieldsAreEmpty() {
		loginButton.disabled = sellernumberTextField.value == '' || passwordTextField.value == '';
	}

	fieldsAreEmpty();
}

export { loginLogic }